import React, { useState, useEffect } from 'react'
import { Col, Row, Form } from 'react-bootstrap'

import FilterRelations from './FilterRelations'

function CityFilter({ filterName, onSetRelation, relation, onSetAttribute, onSetValue }) {
	const relationOptions = ['matches', 'equals', 'in', 'present', 'missing']

	useEffect(() => {
		onSetAttribute(filterName)
	}, [])

	return (
		<Row>
			<Col>
				<FilterRelations relationOptions={relationOptions} onSelectRelation={onSetRelation} />
			</Col>
			<Col>
				{(relation === 'matches' || relation === 'equals') &&
					<Form.Control
						onChange={e => onSetValue(e.target.value)}
						placeholder='ex. California'
					/>
				}
			</Col>
		</Row>
	)
}

export default CityFilter
